import { DeleteOutline } from '@mui/icons-material';
import { Grid, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AddMoreButton from './AddMoreButton';
import FormTextField from './FormTextField';

FormTextFieldWithAddMore.propTypes = {
  fieldName: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
};

export default function FormTextFieldWithAddMore({ fieldName, isEditable = false, focusedField, setFocusedField }) {
  const { control, setValue } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldName,
    keyName: '_id',
  });
  const watchedValues = useWatch({ control, name: fieldName }) || [];
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);
  const disabled = !isEditable || isCanceled;
  const visibleFields = fields
    .map((field, idx) => ({ field, idx }))
    .filter(({ idx }) => !watchedValues[idx]?.deleteFlag);

  const handleDelete = (idx) => {
    const rowId = watchedValues[idx]?.id;

    if (!rowId) {
      remove(idx);
      return;
    }

    setValue(`${fieldName}[${idx}].deleteFlag`, true, {
      shouldDirty: true,
    });
  };

  return (
    <>
      {visibleFields.map(({ field, idx }) => (
        <Grid container alignItems="center" spacing={1} key={field._id} sx={{ mb: 1 }}>
          <Grid item xs={visibleFields.length > 1 ? 11.5 : 12}>
            <FormTextField
              fieldName={`${fieldName}[${idx}].name`}
              fieldAttributes={{ isEditable }}
              focusedField={focusedField}
              setFocusedField={setFocusedField}
            />
          </Grid>
          {visibleFields.length > 1 && (
            <Grid item xs={0.5}>
              <IconButton onClick={() => handleDelete(idx)} disabled={disabled} color="error">
                <DeleteOutline />
              </IconButton>
            </Grid>
          )}
        </Grid>
      ))}
      <AddMoreButton
        buttonLabel="Add more"
        handleAddMoreClick={() => append({ id: 0, name: '', deleteFlag: false })}
        disabled={disabled}
      />
    </>
  );
}
